
// Wilayas d'Algérie (exemple simplifié)
export const wilayas = [
  { code: "01", name: "Adrar" },
  { code: "02", name: "Chlef" },
  { code: "03", name: "Laghouat" },
  { code: "04", name: "Oum El Bouaghi" },
  { code: "05", name: "Batna" },
  { code: "06", name: "Béjaïa" },
  { code: "07", name: "Biskra" },
  { code: "08", name: "Béchar" },
  { code: "09", name: "Blida" },
  { code: "10", name: "Bouira" },
  { code: "11", name: "Tamanrasset" },
  { code: "12", name: "Tébessa" },
  { code: "13", name: "Tlemcen" },
  { code: "14", name: "Tiaret" },
  { code: "15", name: "Tizi Ouzou" },
  { code: "16", name: "Alger" },
  { code: "17", name: "Djelfa" },
  { code: "18", name: "Jijel" },
  { code: "19", name: "Sétif" },
  { code: "20", name: "Saïda" },
  { code: "21", name: "Skikda" },
  { code: "22", name: "Sidi Bel Abbès" },
  { code: "23", name: "Annaba" },
  { code: "24", name: "Guelma" },
  { code: "25", name: "Constantine" },
  { code: "26", name: "Médéa" },
  { code: "27", name: "Mostaganem" },
  { code: "28", name: "M'Sila" },
  { code: "29", name: "Mascara" },
  { code: "30", name: "Ouargla" },
  { code: "31", name: "Oran" },
  { code: "32", name: "El Bayadh" },
  { code: "33", name: "Illizi" },
  { code: "34", name: "Bordj Bou Arreridj" },
  { code: "35", name: "Boumerdès" },
  { code: "36", name: "El Tarf" },
  { code: "37", name: "Tindouf" },
  { code: "38", name: "Tissemsilt" },
  { code: "39", name: "El Oued" },
  { code: "40", name: "Khenchela" },
  { code: "41", name: "Souk Ahras" },
  { code: "42", name: "Tipaza" },
  { code: "43", name: "Mila" },
  { code: "44", name: "Aïn Defla" },
  { code: "45", name: "Naâma" },
  { code: "46", name: "Aïn Témouchent" },
  { code: "47", name: "Ghardaïa" },
  { code: "48", name: "Relizane" },
  { code: "49", name: "Timimoun" },
  { code: "50", name: "Bordj Badji Mokhtar" },
  { code: "51", name: "Ouled Djellal" },
  { code: "52", name: "Béni Abbès" },
  { code: "53", name: "In Salah" },
  { code: "54", name: "In Guezzam" },
  { code: "55", name: "Touggourt" },
  { code: "56", name: "Djanet" },
  { code: "57", name: "El M'Ghair" },
  { code: "58", name: "El Meniaa" }
];

// Communes d'Algérie (exemple simplifié)
export const communes = [
  { code: "0101", name: "Adrar", wilaya_code: "01" },
  { code: "0102", name: "Tamest", wilaya_code: "01" },
  { code: "0103", name: "Reggane", wilaya_code: "01" },
  { code: "0201", name: "Chlef", wilaya_code: "02" },
  { code: "0202", name: "Ténès", wilaya_code: "02" },
  { code: "0203", name: "Bennairia", wilaya_code: "02" },
  { code: "1601", name: "Alger Centre", wilaya_code: "16" },
  { code: "1602", name: "Bab El Oued", wilaya_code: "16" },
  { code: "1603", name: "El Madania", wilaya_code: "16" },
  { code: "1604", name: "Hussein Dey", wilaya_code: "16" },
  { code: "1605", name: "Kouba", wilaya_code: "16" },
  { code: "1606", name: "Bir Mourad Raïs", wilaya_code: "16" },
  { code: "1607", name: "El Biar", wilaya_code: "16" },
  { code: "3101", name: "Oran", wilaya_code: "31" },
  { code: "3102", name: "Bir El Djir", wilaya_code: "31" },
  { code: "3103", name: "Es Sénia", wilaya_code: "31" },
  { code: "3104", name: "Arzew", wilaya_code: "31" },
  { code: "2501", name: "Constantine", wilaya_code: "25" },
  { code: "2502", name: "Hamma Bouziane", wilaya_code: "25" },
  { code: "2503", name: "El Khroub", wilaya_code: "25" }
  // Ajoutez plus de communes au besoin
];
